import { useContext } from 'react';
import { Auth } from 'models/auth';
import { AuthContext } from 'providers/AuthProvider';

export const initialAuth: Auth = {
    user: null,
    userFullName: null,
    userId: null,
    roles: null,
    apiCrmToken: null,
    accessTokenExpires: null,
    accessTokenValid: false,
    tariffEditingAccess: null,
    tariffEditableBillServices: null,
    canViewOrdersWithActiveProlongationAgreements: false,
    portalUserEmployerId: null,
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
      throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
